import { fetchWithAuth } from '../utils/fetchWithAuth';

export interface ServiceDeskOption {
  id: number;
  name: string;
  enabled?: boolean;
  hasCampaigns?: boolean;
  /** The desk writes the qualification workflow into Jira (D17). Absent reads as off. */
  hasInterventionQualification?: boolean;
  /** The desk carries an « heure de passage » field in Jira. Absent reads as off. */
  hasInterventionTime?: boolean;
  /** The desk splits a request into child tickets (a parent column applies). Absent reads as off. */
  splitsIntoChildren?: boolean;
  /** The market it serves (D68-c) — the country whose skills its missions can require. */
  country?: string;
}

interface ServiceDeskRequestTypeOption {
  id: number;
  name: string;
}

/** A desk plus the request types its `allowedFormTypes` exposes, named live from Jira. */
export interface ServiceDeskWithRequestTypes {
  id: number;
  name: string;
  projectKey: string;
  requestTypes: ServiceDeskRequestTypeOption[];
}

export interface ServiceDeskCampaignOption {
  label: string;
  summaryPrefix?: string;
}

export const serviceDesksApi = {
  list: async (): Promise<ServiceDeskOption[]> => {
    const res = await fetchWithAuth('service-desks/all');
    const json = await res.json();
    if (!res.ok || json?.success === false) {
      throw new Error(json?.error || 'Failed to fetch service desks');
    }
    return (json.data ?? []) as ServiceDeskOption[];
  },

  withRequestTypes: async (): Promise<ServiceDeskWithRequestTypes[]> => {
    const res = await fetchWithAuth('service-desks/with-request-types');
    const json = await res.json();
    if (!res.ok || json?.success === false) {
      throw new Error(json?.error || 'Failed to fetch service desks with request types');
    }
    return (json.data ?? []) as ServiceDeskWithRequestTypes[];
  },

  campaigns: async (serviceDeskId: number): Promise<Record<string, ServiceDeskCampaignOption>> => {
    const res = await fetchWithAuth(`service-desks/${serviceDeskId}/campaigns`);
    const json = await res.json();
    if (!res.ok || json?.success === false) {
      throw new Error(json?.error || 'Failed to fetch service desk campaigns');
    }
    return (json.data ?? {}) as Record<string, ServiceDeskCampaignOption>;
  },
};
